import { render, staticRenderFns } from "./RecentApplications.vue?vue&type=template&id=77cd5c54&"
import script from "./RecentApplications.vue?vue&type=script&lang=js&"
export * from "./RecentApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports